import { SuppliersIndex, SuppliersEditor } from "../views";

export const supplierRouter = [
  {
    path: "suppliers",
    name: "SuppliersIndex",
    component: SuppliersIndex
  },
  {
    path: "suppliers/edit/:id?",
    name: "SuppliersEditor",
    component: SuppliersEditor,
    props: true
  }
];
